import {
  formatDateToMDY,
  getItineraryEndDate,
  formatUtcDate,
  buildItineraryTimes,
  normalizeLocations,
} from "../helpers/GetAQuoteHelpers";
import axios from "axios";

const API_URL_DOMAIN = import.meta.env.VITE_APP_BASE_DOMAIN;
const VITE_APP_PHONE_VALIDATE_URL = import.meta.env.VITE_APP_PHONE_VALIDATE_URL;
const VITE_APP_PHONE_API_KEY = import.meta.env.VITE_APP_PHONE_API_KEY;

export const validatePhoneNumber = async (phoneNumber) => {
  try {
    const response = await axios.get(VITE_APP_PHONE_VALIDATE_URL, {
      params: {
        api_key: VITE_APP_PHONE_API_KEY,
        phone: phoneNumber,
      },
    });

    return response.data.valid;
  } catch (error) {
    console.error(
      "Phone validation failed:",
      error.response?.data || error.message,
    );

    return true; // Default to valid phone number if API call fails
  }
};

export const sendTripData = async (data) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${API_URL_DOMAIN}/api/v1/leads/create`,
      generatePayload(data),
      config,
    );

    if (response.data) {
      // If redirect_path contains full URL
      if (response.data.redirect_path.includes("http")) {
        window.location.href = response.data.redirect_path;
      } else {
        window.parent.postMessage(
          { type: "REDIRECT", url: response.data.redirect_path },
          "*",
        );
      }
    }

    return {
      success: true,
    };
  } catch (error) {
    console.error("Error submitting data:", error);

    return {
      success: false,
    };
  }
};

const TRIP_TYPE_LABEL = {
  one_way: "One Way",
  custom: "One Way",
  round_trip: "Round Trip",
  shuttle: "Shuttle",
  other: "Other",
  large_event: "Other",
};

const generatePayload = (formData) => {
  const locations = formData.locations;
  const tripType = TRIP_TYPE_LABEL[formData.tripType];
  const tripInfoData = formData.tripInfoData;
  const contactInfoData = formData.contactInfoData;
  const uploadUrls = formData.uploaded_files;
  const host = window.location.href;

  let itinerary = [];
  if (tripType === "Other" && formData.other_date && formData.duration) {
    itinerary = normalizeLocations(
      locations,
      formData.other_date,
      formData.duration,
    );
  } else {
    const times = buildItineraryTimes(locations);
    itinerary = locations.map((loc, i) => ({
      location: { ...loc },
      ...times[i],
    }));
  }

  const resultArr = {
    current_page: host || "",
    data: {
      travelstartdate_c: locations[0]?.date
        ? formatDateToMDY(locations[0]?.date)
        : "",
      travelenddate_c: locations[0]?.date ? getItineraryEndDate(locations) : "",
      origincity_c: locations?.[0]?.city || "",
      originstate_c: locations?.[0]?.state || "",
      passengers: tripInfoData["est._number_of_passengers"] || null,
      sms_opt_in: contactInfoData.agree_to_sms,
      description: `Comments: ${tripInfoData.comments}`,
      email: contactInfoData.email,
      first_name: contactInfoData.first_name,
      last_name: contactInfoData.last_name,
      phone: contactInfoData.phone,
      submitted: formatUtcDate,
      account_name: contactInfoData.company,
      lead_source_description: "Static Quote v2",
      segment_c: tripInfoData.group_type,
      preferred_coach_type_c: tripInfoData.preferred_bus_type,
      uploadUrls: uploadUrls,
      tripType: tripType || "",
      stops: itinerary,
      duration: formData.duration,
      city: formData.city,
      use_diy: formData.use_diy || false,
    },
  };

  return resultArr;
};
